import { NativeSelect } from "@mui/material";
import { IFavouritesFolder } from "./favouritesProvider";

export interface FolderSelectProps {
    selectedValue: number;
    setSelectedValue: (n: number) => void;
    folders: IFavouritesFolder[];
}

export const FolderSelect = (props: FolderSelectProps) => {


    return (
        <NativeSelect
            value={props.selectedValue}
            onChange={(e) => {
                let n = Number(e.target.value);
                if (!isNaN(n) && n > 0) props.setSelectedValue(n);
            }}
            sx={{flexGrow: 1}}
        >
            {
                props.folders.map(f => <option value={f.id} key={f.id}>
                    {f.name}
                </option>)
            }
        </NativeSelect>
    )
}